/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Product_NotesInputs */

const vi_customer_product_notes = /** @type {(inputs: Customer_Product_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ghi chú sản phẩm`)
};

/**

* @param {Customer_Product_NotesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_product_notes = /** @type {((inputs?: Customer_Product_NotesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Product_NotesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_product_notes(inputs)
});